import { useAuthenticationApi } from "../api/AuthenticationApiClient";
import { AuthenticationFrontendService } from "../services/AuthenticationFrontendService";

export const useAuthenticationService = (): AuthenticationFrontendService =>
  new AuthenticationFrontendService(useAuthenticationApi());
